var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.textBanner.length > 0
    ? _c("div", { staticClass: "text-banner" }, [
        _c(
          "ul",
          _vm._l(_vm.textBanner, function (banner) {
            return _c("li", { key: banner.id }, [
              banner.contentType === 1
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleDrugInfoClick(banner.contentId)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "info-type banner-item" }, [
                        _vm._v("약품정보"),
                      ]),
                      _c("span", { staticClass: "banner-txt" }, [
                        _vm._v(_vm._s(banner.bannerText)),
                      ]),
                    ]
                  )
                : banner.contentType === 2
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleMedicalTrendClick(banner.contentId)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "trend-type banner-item" }, [
                        _vm._v("메디컬 트렌드"),
                      ]),
                      _c("span", { staticClass: "banner-txt" }, [
                        _vm._v(_vm._s(banner.bannerText)),
                      ]),
                    ]
                  )
                : banner.contentType === 3
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleSurveyClick(banner.contentId)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "survey-type banner-item" }, [
                        _vm._v("설문조사"),
                      ]),
                      _c("span", { staticClass: "banner-txt" }, [
                        _vm._v(_vm._s(banner.bannerText)),
                      ]),
                    ]
                  )
                : banner.contentType === 5
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleWebseminarClick(banner.contentId)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "seminar-type banner-item" }, [
                        _vm._v("웹세미나"),
                      ]),
                      _c("span", { staticClass: "banner-txt" }, [
                        _vm._v(_vm._s(banner.bannerText)),
                      ]),
                    ]
                  )
                : banner.contentType === 6
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleNoticeClick(banner.contentId)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "notice-type banner-item" }, [
                        _vm._v("공지사항"),
                      ]),
                      _c("span", { staticClass: "banner-txt" }, [
                        _vm._v(_vm._s(banner.bannerText)),
                      ]),
                    ]
                  )
                : banner.contentType === 7
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleEventClick(banner.contentId)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "event-type banner-item" }, [
                        _vm._v("이벤트"),
                      ]),
                      _c("span", { staticClass: "banner-txt" }, [
                        _vm._v(_vm._s(banner.bannerText)),
                      ]),
                    ]
                  )
                : banner.contentType === 8
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.callDrugLanding(banner.contentId)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "medical-type banner-item" }, [
                        _vm._v("간편처방 등록"),
                      ]),
                      _c("span", { staticClass: "banner-txt" }, [
                        _vm._v(_vm._s(banner.bannerText)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }